import styled from 'styled-components';

import Button from '../Button';
import {
  modalButtonContainerStyle,
  modalButtonPrimaryStyle,
  modalButtonSecondaryStyle,
  modalContainerStyle,
  modalStyle,
} from '../../constants/modals';

const Container = styled.div`
  ${modalContainerStyle}
`;

const StyledModal = styled.div`
  ${modalStyle}
`;

const StyledText = styled.div`
  width: 100%;
  text-align: center;
  padding-top: 10px;
`;

const ControlsContainer = styled.div`
  display: flex;
  justify-content: end;
  width: 100%;
  padding-top: 10px;
`;

const StyledButtonContainer = styled.div`
  ${modalButtonContainerStyle}
`;

const StyledSecondaryButton = styled(Button)`
  ${modalButtonSecondaryStyle}
`;
const StyledPrimaryButton = styled(Button)`
  ${modalButtonPrimaryStyle}
`;

export {
  Container,
  StyledModal,
  StyledText,
  ControlsContainer,
  StyledButtonContainer,
  StyledSecondaryButton,
  StyledPrimaryButton,
};
